import { InMemoryDbService } from 'angular-in-memory-web-api';

export class InMemoryDataService implements InMemoryDbService {
  createDb() {

    let inventoryStages = [
      {
        "id": 1,
        "stageName": "Prospecting",
        "status": "Open",
        "probability": 10,
        "category": "Pipeline",
        "color": "#FF0000",
        "isActive": "yes",
        "note": "",
      },
      {
        "id": 2,
        "stageName": "Investigation",
        "status": "Open",
        "probability": 30,
        "category": "Pipeline",
        "color": "#3E476B",
        "isActive": "yes",
        "note": "",
      },
      {
        "id": 3,
        "stageName": "Proposal Made",
        "status": "Open",
        "probability": 50,
        "category": "Pipeline",
        "color": "#3C6844",
        "isActive": "yes",
        "note": "",
      },
      {
        "id": 4,
        "stageName": "Negotiation",
        "status": "Open",
        "probability": 80,
        "category": "Pipeline",
        "color": "#439664",
        "isActive": "yes",
        "note": "",
      },
      {
        "id": 5,
        "stageName": "Closed Won",
        "status": "Closed Won",
        "probability": 100,
        "category": "Won",
        "color": "#CE1C18",
        "isActive": "yes",
        "note": "",
      },
      {
        "id": 6,
        "stageName": "Closed Lost",
        "status": "Closed Lost",
        "probability": 0,
        "category": "Lost",
        "color": "#999999",
        "isActive": "yes",
        "note": "",
      }
    ]

    let CaseChannels = [
      {
        "id": 1,
        "channelName": "Customer Support",
        "stagesNo": 5,
        "createdUser": "Admin",
        "createdBy": 3,
        "createDate": "",
        "createdSource": "",
        "updatedSource": "",
        "updatedBy": "",
        "updatedDate": "12/04/2020",
        "isActive": "yes",
        "isDefault": "yes",
      },
      {
        "id": 2,
        "channelName": "Sales",
        "stagesNo": 4,
        "createdUser": "Admin",
        "createdBy": 3,
        "createDate": "",
        "createdSource": "",
        "updatedSource": "",
        "updatedBy": "",
        "updatedDate": "04/04/2021",
        "isActive": "yes",
        "isDefault": "no",
      },
      {
        "id": 3,
        "channelName": "Tech Support",
        "stagesNo": 5,
        "createdUser": "Admin",
        "createdBy": 3,
        "createDate": "",
        "createdSource": "",
        "updatedSource": "",
        "updatedBy": "",
        "updatedDate": "04/04/2021",
        "isActive": "yes",
        "isDefault": "no",
      },
      {
        "id": 4,
        "channelName": "Finance",
        "stagesNo": 4,
        "createdUser": "Admin",
        "createdBy": 3,
        "createDate": "",
        "createdSource": "",
        "updatedSource": "",
        "updatedBy": "",
        "updatedDate": "04/04/2021",
        "isActive": "yes",
        "isDefault": "no",
      },
    ];

    let CaseTemplates = [
      {
        "id": 1,
        "templateName": "Case",
        "channelId": 1,
        "channel": {
          "id": 1,
          "name": "Customer Support",
        },
        "createdUser": "Default",
        "createdBy": 3,
        "createDate": "",
        "createdSource": "",
        "updatedSource": "",
        "updatedBy": "",
        "updatedDate": "03/21/2021",
        "color": "#CE1C18",
        "isActive": "yes",
        "labels": [
          { id: 1, labelname: "Case Association", code: "case asso", checked: true, width: "6", movable: false, showForDrag: true },
          { id: 2, labelname: "Association Name", code: "asso name", checked: true, width: "6", movable: false, showForDrag: true },
          { id: 3, labelname: "Contact Name", code: "contact name", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 4, labelname: "Contact Email Address", code: "contact email", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 5, labelname: "Contact Phone Number", code: "contact phone", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 6, labelname: "Source", code: "contact source", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 7, labelname: "Category", code: "cate", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 8, labelname: "Sub - Category", code: "sub cate", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 9, labelname: "Priority", code: "priority", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 10, labelname: "Share Files (Max Size 2MB)", code: "share files", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 11, labelname: "Case Details", code: "case notes", checked: true, width: "12", movable: true, showForDrag: true },
        ]
      },
      {
        "id": 2,
        "templateName": "Sales_temp",
        "channelId": 2,
        "channel": {
          "id": 2,
          "name": "Sales",
        },
        "createdUser": "Admin",
        "createdBy": 3,
        "createDate": "",
        "createdSource": "",
        "updatedSource": "",
        "updatedBy": "",
        "updatedDate": "04/12/2021",
        "color": "#CE1C18",
        "isActive": "yes",
        "labels": [
          { id: 1, labelname: "Case Association", code: "case asso", checked: true, width: "6", movable: false, showForDrag: true },
          { id: 2, labelname: "Association Name", code: "asso name", checked: true, width: "6", movable: false, showForDrag: true },
          { id: 3, labelname: "Contact Name", code: "contact name", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 4, labelname: "Contact Email Address", code: "contact email", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 5, labelname: "Contact Phone Number", code: "contact phone", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 6, labelname: "Source", code: "contact source", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 7, labelname: "Category", code: "cate", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 8, labelname: "Sub - Category", code: "sub cate", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 9, labelname: "Priority", code: "priority", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 10, labelname: "Share Files (Max Size 2MB)", code: "share files", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 11, labelname: "Case Details", code: "case notes", checked: true, width: "12", movable: true, showForDrag: true },
        ]
      },
      {
        "id": 3,
        "templateName": "Tech Support_temp",
        "channelId": 3,
        "channel": {
          "id": 3,
          "name": "Tech Support",
        },
        "createdUser": "Admin",
        "createdBy": 3,
        "createDate": "",
        "createdSource": "",
        "updatedSource": "",
        "updatedBy": "",
        "updatedDate": "04/12/2021",
        "color": "#CE1C18",
        "isActive": "yes",
        "labels": [
          { id: 1, labelname: "Case Association", code: "case asso", checked: true, width: "6", movable: false, showForDrag: true },
          { id: 2, labelname: "Association Name", code: "asso name", checked: true, width: "6", movable: false, showForDrag: true },
          { id: 3, labelname: "Contact Name", code: "contact name", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 4, labelname: "Contact Email Address", code: "contact email", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 5, labelname: "Contact Phone Number", code: "contact phone", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 6, labelname: "Source", code: "contact source", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 7, labelname: "Category", code: "cate", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 8, labelname: "Sub - Category", code: "sub cate", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 9, labelname: "Priority", code: "priority", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 10, labelname: "Share Files (Max Size 2MB)", code: "share files", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 11, labelname: "Case Details", code: "case notes", checked: true, width: "12", movable: true, showForDrag: true },
        ]
      },
      {
        "id": 4,
        "templateName": "Finance_temp",
        "channelId": 4,
        "channel": {
          "id": 4,
          "name": "Finance",
        },
        "createdUser": "Admin",
        "createdBy": 3,
        "createDate": "",
        "createdSource": "",
        "updatedSource": "",
        "updatedBy": "",
        "updatedDate": "04/12/2021",
        "color": "#CE1C18",
        "isActive": "yes",
        "labels": [
          { id: 1, labelname: "Case Association", code: "case asso", checked: true, width: "6", movable: false, showForDrag: true },
          { id: 2, labelname: "Association Name", code: "asso name", checked: true, width: "6", movable: false, showForDrag: true },
          { id: 3, labelname: "Contact Name", code: "contact name", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 4, labelname: "Contact Email Address", code: "contact email", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 5, labelname: "Contact Phone Number", code: "contact phone", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 6, labelname: "Source", code: "contact source", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 7, labelname: "Category", code: "cate", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 8, labelname: "Sub - Category", code: "sub cate", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 9, labelname: "Priority", code: "priority", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 10, labelname: "Share Files (Max Size 2MB)", code: "share files", checked: true, width: "6", movable: true, showForDrag: true },
          { id: 11, labelname: "Case Details", code: "case notes", checked: true, width: "12", movable: true, showForDrag: true },
        ]
      }
    ]

    let OpportunityPipelines = [
      { id: 1, pipelineName: "Default Chanel" },
      { id: 2, pipelineName: "Service Based" },
      { id: 3, pipelineName: "Test Computers" },
      { id: 4, pipelineName: "Star Books" },
      { id: 5, pipelineName: "Acme Corporation" }
    ]

    let units = [
      { id: 1, unit: "Pieces" },
      { id: 2, unit: "Kg" },
      { id: 3, unit: "gm" },
      { id: 4, unit: "litre" }
    ]

    let Gender = [
      { id: 1, name: "Male" },
      { id: 2, name: "Female" },
    ]

    let Language = [
      { id: 1, name: 'English', code: 'en' },
      { id: 2, name: 'French', code: 'french' },
      { id: 3, name: 'Indian', code: 'indian' },
      { id: 4, name: 'Chinese', code: 'cn' }
    ]

    let reminderTypes = [
      {
        id: 1,
        name: "Email",
        isActive: true
      },
      {
        id: 2,
        name: "Message",
        isActive: true
      }
    ]

    let reminderDelays = [
      {
        id: 1,
        name: "Before 15 minutes",
        value: 15,
        isActive: true
      },
      {
        id: 2,
        name: "Before 30 minutes",
        value: 30,
        isActive: true
      },
      {
        id: 3,
        name: "Before 45 minutes",
        value: 45,
        isActive: true
      },
      {
        id: 4,
        name: "Before 1 hour",
        value: 60,
        isActive: true
      },
      {
        id: 5,
        name: "Before 2 hours",
        value: 120,
        isActive: true
      },
      {
        id: 6,
        name: "Before 1 day",
        value: 1440,
        isActive: true
      },
      {
        id: 7,
        name: "Before 7 days",
        value: 10080,
        isActive: true
      },
      {
        id: 8,
        name: "Before 30 days",
        value: 43200,
        isActive: true
      },
    ]

    let repeat = [
      {
        id: 3,
        type: "Daily"
      },
      {
        id: 4,
        type: "Weekly"
      }
    ]

    let priority = [
      {
        id: 1,
        priority: "Low"
      },
      {
        id: 2,
        priority: "Moderate"
      },
      {
        id: 3,
        priority: "High"
      },
    ]

    let taskStatuses = [
      {
        id: 4,
        name: "Assigned",
        groupId: 3
      },
      {
        id: 5,
        name: "In Progress",
        groupId: 3
      },
      {
        id: 6,
        name: "Completed",
        groupId: 3
      },
      {
        id: 7,
        name: "Accepted",
        groupId: 3
      },
    ]

    return {
      inventoryStages,
      CaseChannels,
      CaseTemplates,
      OpportunityPipelines,
      units,
      taskStatuses,
      reminderTypes,
      reminderDelays,
      repeat,
      priority,
      Gender,
      Language
    };

  }
}
